export {};
//# sourceMappingURL=IOfflineProvider.js.map